var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import ListGroup from 'react-bootstrap/ListGroup';
import { isMobile, useMobileOrientation } from 'react-device-detect';
import '../../styles/PopUp.css';
import { useLanguage } from '../context/LanguageContext';
import { useAppState } from '../context/AppStateContext';
export default function MultiPopUp(props) {
    var language = useLanguage().language;
    var productNameMulti = useAppState().productNameMulti;
    var isLandscape = useMobileOrientation().isLandscape;
    var filePath = "./Ressources/".concat(productNameMulti, "/").concat(props.subsidiaryForTexts, "_textes_liens_").concat(productNameMulti, "_").concat(language, ".json");
    var _a = useState([]), menu = _a[0], setMenu = _a[1];
    var _b = useState(true), isOpen = _b[0], setOpen = _b[1];
    var _c = useState(false), isShown = _c[0], setIsShown = _c[1];
    var _d = useState(false), visible = _d[0], setVisible = _d[1];
    var _e = useState("element_0"), selectedItem = _e[0], setSelectedItem = _e[1];
    function changeUIColor(id) {
        setSelectedItem(id);
    }
    function updateText() {
        fetch(filePath, {
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
        })
            .then(function (r) { return r.json(); })
            .then(function (data) { var _a; return setMenu((_a = data.menu) !== null && _a !== void 0 ? _a : []); });
    }
    useEffect(function () {
        if (productNameMulti !== "") {
            updateText();
            setIsShown(true);
        }
        else
            setIsShown(false);
    }, [language, productNameMulti]);
    // Lorsque l'utilisateur change de produit 3D (productNameMulti),
    // réinitialiser la sélection sur le premier élément.
    useEffect(function () {
        if (productNameMulti !== "") {
            setSelectedItem("element_0");
        }
    }, [productNameMulti]);
    var firstClickable = menu[0] ? (_jsx(ClickableElement, { title: menu[0].title, objName: menu[0].nameObj, folderName: menu[0].nameFolder, changeUIColor: changeUIColor, outlineObj: props.outlineObj, index: 0, selectedItem: selectedItem }, 0)) : null;
    var toggleTitle = (_jsx("li", __assign({ className: "item toggle-title" }, { children: _jsxs("button", __assign({ type: "button", className: "toggle-btn", onClick: function () { return setOpen(!isOpen); }, tabIndex: 0, "aria-expanded": isOpen }, { children: ["Produits disponibles en standard", _jsx("span", __assign({ style: { marginLeft: 8 } }, { children: isOpen ? _jsx(FontAwesomeIcon, { icon: faChevronUp }) : _jsx(FontAwesomeIcon, { icon: faChevronDown }) }))] })) })));
    /* ----------- Rendu selon contexte ----------- */
    // 1. MOBILE PORTRAIT → étiquette + menu coulissant
    if (isMobile && !isLandscape) {
        return (_jsxs(_Fragment, { children: [isShown && (_jsx("button", __assign({ className: "multi-toggle-bottom ".concat(visible ? "open" : ""), onClick: function () { return setVisible(!visible); }, "aria-label": "Afficher les produits" }, { children: visible ? "– Produits" : "+ Produits" }))), _jsx("nav", __assign({ className: "menu_multi_bottom ".concat(visible ? "open" : "closed"), style: { display: isShown ? "block" : "none" } }, { children: _jsxs("ul", __assign({ className: "menu-multi-list" }, { children: [_jsx("li", __assign({ className: "menu-multi-header" }, { children: _jsx("h3", __assign({ id: "configs-title", className: "menu-multi-title" }, { children: "Configurations disponibles" })) })), firstClickable && _jsx("li", { children: firstClickable }), toggleTitle, isOpen &&
                                menu.slice(1).map(function (el, idx) { return (_jsx("li", { children: _jsx(ClickableElement, { title: el.title, objName: el.nameObj, folderName: el.nameFolder, changeUIColor: changeUIColor, outlineObj: props.outlineObj, index: idx + 1, selectedItem: selectedItem }) }, idx + 1)); })] })) }))] }));
    }
    // 2. MOBILE PAYSAGE ou DESKTOP → version normale (à droite de la pop-up)
    return (_jsx("nav", __assign({ className: isOpen ? "menu_multi_product open" : "menu_multi_product", style: { display: isShown ? "block" : "none" } }, { children: _jsxs("ul", __assign({ className: "menu-multi-list" }, { children: [_jsx("li", __assign({ className: "menu-multi-header" }, { children: _jsx("h3", __assign({ id: "configs-title", className: "menu-multi-title" }, { children: "Configurations disponibles" })) })), firstClickable && _jsx("li", { children: firstClickable }), toggleTitle, isOpen &&
                    menu.slice(1).map(function (el, idx) { return (_jsx("li", { children: _jsx(ClickableElement, { title: el.title, objName: el.nameObj, folderName: el.nameFolder, changeUIColor: changeUIColor, outlineObj: props.outlineObj, index: idx + 1, selectedItem: selectedItem }) }, idx + 1)); })] })) })));
}
/* ---------- Éléments enfants ---------- */
function TitleElement(props) {
    var isLandscape = useMobileOrientation().isLandscape;
    return (_jsx(ListGroup.Item, __assign({ className: "item", style: { padding: isMobile && isLandscape ? "6.5px 11px" : "11.5px 11px" } }, { children: _jsx("b", { children: props.title }) })));
}
function ClickableElement(props) {
    var isLandscape = useMobileOrientation().isLandscape;
    var setProductName = useAppState().setProductName;
    function handleHoverStart() {
        props.outlineObj(props.objName, 10);
    }
    function handleHoverEnd() {
        props.outlineObj(props.objName, 0);
    }
    function handleClick() {
        setProductName(props.folderName);
        props.changeUIColor("element_" + props.index);
    }
    return (_jsx("button", __assign({ className: (props.selectedItem === "element_" + props.index ? "item item_selected" : "item") +
            (props.index !== 0 ? " subitem" : ""), id: "element_" + props.index, onClick: handleClick, onMouseEnter: handleHoverStart, onMouseLeave: handleHoverEnd }, { children: _jsx("b", { children: props.title }) })));
}
